import { Money } from "src/api/Money";
import { AmountUtil } from "./AmountUtil";


export const MoneyUtil = {

    merge(list?: Array<Money | null | undefined>): Money[] {
        const totalsByCurrency = (list ?? [])
            .filter((money): money is Money => money != null)
            .reduce<Record<string, Money[]>>((totals, money) => {
                totals[money.currency] = totals[money.currency] ?? [];
                totals[money.currency].push(money);
                return totals;
            }, {});

        return Object.keys(totalsByCurrency).map(function (key) {
            return {
                value: totalsByCurrency[key].reduce((a, v) => a + v.value, 0),
                currency: key
            }
        });
    },

    sumAmount(list: Money[]): number {
        return list.reduce((a, v) => a + v.value, 0);
    },

    format(money?: Money): string {
         return money ? AmountUtil.format(money.value) + ' ' + money.currency : '-'
    }
}
